/**
 * Like pluck, but it plucks from each thing in a list.
 */

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { pipe } from 'rxjs/util/pipe';

export function pluckList<T, P1 extends keyof T>(
  property1: P1,
): ((source: Observable<ReadonlyArray<T>>) => Observable<ReadonlyArray<T[P1]>>);

export function pluckList<T, P1 extends keyof T>(
  property1: P1,
): ((source: Observable<T[]>) => Observable<T[P1][]>);

export function pluckList<T, P1 extends keyof T>(
  property1: P1,
): ((source: Observable<ReadonlyArray<T>>) => Observable<T[P1][]>) {
  return pipe(map(xs => xs.map(x => x[property1])));
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/operators/pluckList.ts